export default {
    when() {
        return (
            document.querySelectorAll('.custom-js-redirect-template').length > 0
        );
    },

    mounted() {
        let url = document.querySelector('.custom-js-redirect-template')
            .attributes.redirect.value;
        if (window.location.href !== url) {
            window.location.href = url;
        }
    },
};
